const helix=document.querySelector('.helix');for(let i=0;i<32;i++){const r=document.createElement('span');r.className='rung';r.style.setProperty('--i',i);r.style.setProperty('--scale',Math.abs(Math.cos(i*.24))*.8+.2);r.innerHTML='<b></b>';helix.append(r)}const mini=document.querySelector('.mini-helix');for(let i=0;i<28;i++){const r=document.createElement('span');r.className='rung';r.style.setProperty('--i',i);r.style.setProperty('--scale',Math.abs(Math.cos(i*.38))*.8+.2);r.innerHTML='<b></b>';mini.append(r)}document.getElementById('motion').addEventListener('click',e=>{const paused=document.body.classList.toggle('paused');e.currentTarget.setAttribute('aria-pressed',String(paused));e.currentTarget.setAttribute('aria-label',paused?'Resume DNA animation':'Pause DNA animation');e.currentTarget.textContent=paused?'▶':'Ⅱ'});const menu=document.querySelector('.menu-toggle');menu.addEventListener('click',()=>{const open=document.getElementById('nav').classList.toggle('open');menu.setAttribute('aria-expanded',String(open))});document.querySelectorAll('nav a').forEach(a=>a.addEventListener('click',()=>{document.getElementById('nav').classList.remove('open');menu.setAttribute('aria-expanded','false')}));document.querySelectorAll('[data-open]').forEach(b=>b.addEventListener('click',()=>document.getElementById(b.dataset.open).showModal()));document.querySelectorAll('dialog').forEach(d=>{d.querySelector('.close').addEventListener('click',()=>d.close());d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close()}})});document.getElementById('year').textContent=new Date().getFullYear();

(() => {
  const host = document.querySelector('.gene-helix');
  if (!host) return;

  const canvas = document.createElement('canvas');
  canvas.setAttribute('aria-hidden', 'true');
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  host.append(canvas);
  host.classList.add('dna-roll-ready');

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let width = 0;
  let height = 0;
  let phase = 0.45;
  let previous = 0;
  let visible = false;

  function sizeCanvas() {
    const bounds = host.getBoundingClientRect();
    width = Math.max(1, Math.round(bounds.width));
    height = Math.max(1, Math.round(bounds.height));
    const ratio = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(width * ratio);
    canvas.height = Math.round(height * ratio);
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    draw();
  }

  function point(x, strand) {
    const margin = 18;
    const t = (x - margin) / Math.max(1, width - 2 * margin);
    const taper = Math.min(1, Math.max(0, t) * 7, Math.max(0, 1 - t) * 7);
    const angle = t * Math.PI * 5 + phase;
    const depth = strand * Math.cos(angle);
    const radius = Math.min(height * 0.30, 56) * taper;
    return { y: height / 2 + strand * Math.sin(angle) * radius, depth, taper };
  }

  function dot(x, y, radius, alpha, color) {
    ctx.globalAlpha = alpha;
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.arc(x, y, radius, 0, Math.PI * 2);
    ctx.fill();
  }

  function draw() {
    ctx.clearRect(0, 0, width, height);
    const left = 18;
    const right = width - 18;
    if (right <= left) return;

    // Rungs rotate in depth with their endpoints; the near side glows brighter.
    const rungs = Math.max(22, Math.round((right - left) / 15));
    for (let i = 0; i <= rungs; i++) {
      const x = left + (right - left) * i / rungs;
      const a = point(x, 1);
      const b = point(x, -1);
      const fade = Math.min(1, i / 3, (rungs - i) / 3);
      ctx.globalAlpha = (0.30 + 0.27 * Math.abs(a.depth)) * fade;
      ctx.strokeStyle = '#50d8fa';
      ctx.lineWidth = 1.4;
      ctx.beginPath();
      ctx.moveTo(x, a.y);
      ctx.lineTo(x, b.y);
      ctx.stroke();
    }

    // Draw the far rail first, then the near rail at each particle position.
    const count = Math.max(120, Math.round((right - left) / 2.6));
    for (const near of [false, true]) {
      for (let i = 0; i <= count; i++) {
        const x = left + (right - left) * i / count;
        for (const strand of [1, -1]) {
          const p = point(x, strand);
          if ((p.depth >= 0) !== near) continue;
          const seed = Math.sin(i * 23.71 + strand * 7.13) * 43758.5453;
          const jitter = (seed - Math.floor(seed) - 0.5) * 3.2;
          const brightness = (near ? 0.74 : 0.34) * Math.min(1, p.taper * 3);
          const size = (near ? 2.35 : 1.55) * (0.75 + 0.25 * Math.abs(p.depth));
          if (i % 4 === 0) {
            ctx.shadowColor = '#23c9ff';
            ctx.shadowBlur = near ? 11 : 5;
          } else {
            ctx.shadowBlur = 0;
          }
          dot(x, p.y + jitter, size, brightness, near ? '#80e6ff' : '#2e9bc7');
          if (near && i % 19 === 0) dot(x, p.y, size * 0.55, 0.9, '#e3fbff');
        }
      }
    }
    ctx.shadowBlur = 0;
    ctx.globalAlpha = 1;
  }

  function tick(now) {
    if (!visible) return;
    if (previous && !reduced.matches && !document.body.classList.contains('paused')) {
      phase += Math.min(now - previous, 60) * 0.00095;
      draw();
    }
    previous = now;
    requestAnimationFrame(tick);
  }

  const observer = new IntersectionObserver(entries => {
    const inView = entries[0].isIntersecting;
    if (inView && !visible) {
      visible = true;
      previous = 0;
      requestAnimationFrame(tick);
    } else if (!inView) {
      visible = false;
    }
  });
  observer.observe(host);
  new ResizeObserver(sizeCanvas).observe(host);
  reduced.addEventListener('change', draw);
  sizeCanvas();
})();
